import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _class, _temp2;

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash.includes';
import mdr from 'mobiledoc-dom-renderer';
import { allCards } from '../';
import { slugify } from '../lib/utils';

var Renderer = mdr;

var mergeCards = function mergeCards(base, overrides) {
  var names = overrides.map(function (_ref) {
    var name = _ref.name;
    return name;
  });
  var filtered = allCards.filter(function (c) {
    return !includes(names, c.name);
  });

  return filtered.concat(overrides);
};

var Content = (_temp2 = _class = function (_Component) {
  _inherits(Content, _Component);

  function Content() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Content);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Content.__proto__ || _Object$getPrototypeOf(Content)).call.apply(_ref2, [this].concat(args))), _this), _this.onLoad = function () {
      var _this$props = _this.props,
          content = _this$props.content,
          onLoad = _this$props.onLoad;

      if (!onLoad) return;

      var doc = JSON.parse(content);
      _this.props.onLoad({
        headers: doc.cards.filter(function (c) {
          return c[0] === 'HeaderCard';
        }).map(function (c) {
          return c[1];
        }).map(function (_ref3) {
          var title = _ref3.title;
          return { id: slugify(title), title: title };
        })
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Content, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var content = this.props.content;

      if (!content) return;
      var renderer = new Renderer({
        cards: mergeCards(allCards, this.props.cards),
        unknownCardHandler: this.props.unknownCardHandler
      });

      var _renderer$render = renderer.render(JSON.parse(content)),
          result = _renderer$render.result;

      this.ref.appendChild(result);
      this.onLoad();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          content = _props.content,
          cards = _props.cards,
          unknownCardHandler = _props.unknownCardHandler,
          onLoad = _props.onLoad,
          props = _objectWithoutProperties(_props, ['content', 'cards', 'unknownCardHandler', 'onLoad']);

      return React.createElement('div', _extends({
        ref: function ref(_ref4) {
          _this2.ref = _ref4;
        }
      }, props));
    }
  }]);

  return Content;
}(Component), _class.propTypes = {
  content: PropTypes.string,
  cards: PropTypes.array,
  unknownCardHandler: PropTypes.func,
  onLoad: PropTypes.func
}, _class.defaultProps = {
  content: null,
  cards: [],
  unknownCardHandler: function unknownCardHandler(_ref5) {
    var name = _ref5.env.name;
    return console.error('Unknown card type ' + name + ' encountered.');
  },
  onLoad: null
}, _temp2);
export { Content as default };